// extracted by mini-css-extract-plugin
module.exports = {"wrap":"InnerButtonMargin_wrap__sAYSf","wrap-right":"InnerButtonMargin_wrap-right__ZGoq1"};